// src/auth/AuthManager.jsx (Example path)

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useIsAuthenticated } from "@azure/msal-react";
import { setAuthReady } from "../store/headerSlice"; // Adjust the import path as needed

/**
 * This component manages the global authentication state, signaling
 * to the rest of the app when the initial auth check is complete.
 */
const AuthManager = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    // This effect runs whenever the authentication status is determined or changes.
    // By dispatching here, we ensure the rest of the app knows it's safe to proceed.
    console.log("Authentication check complete. Setting auth ready.");
    dispatch(setAuthReady());
  }, [isAuthenticated, dispatch]);

  return null; // This component does not render anything
};

export default AuthManager;